/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserResponseDto
 */
export interface UserResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof UserResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    role: UserResponseDtoRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    isNamedUnderwriter?: boolean;
}


/**
 * @export
 */
export const UserResponseDtoRoleEnum = {
    Underwriter: 'Underwriter',
    Finance: 'Finance',
    Claims: 'Claims',
    SuperUser: 'Super User'
} as const;
export type UserResponseDtoRoleEnum = typeof UserResponseDtoRoleEnum[keyof typeof UserResponseDtoRoleEnum];


/**
 * Check if a given object implements the UserResponseDto interface.
 */
export function instanceOfUserResponseDto(value: object): value is UserResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function UserResponseDtoFromJSON(json: any): UserResponseDto {
    return UserResponseDtoFromJSONTyped(json, false);
}

export function UserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'userId': json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'role': json['role'],
        'isNamedUnderwriter': json['isNamedUnderwriter'] == null ? undefined : json['isNamedUnderwriter'],
    };
}

export function UserResponseDtoToJSON(json: any): UserResponseDto {
    return UserResponseDtoToJSONTyped(json, false);
}

export function UserResponseDtoToJSONTyped(value?: UserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'userId': value['userId'],
        'email': value['email'],
        'name': value['name'],
        'role': value['role'],
        'isNamedUnderwriter': value['isNamedUnderwriter'],
    };
}

